import { FormGroup } from 'reactstrap'
import OccupationSelection from './occupation-selection'
import { Checkbox } from 'common-components'

const OtherOccupationSelection = ({
  selectedOccupation,
  occupations,
  natureOfDuties,
  errors,
  selectedNatureOfDutyCode,
  selectOccupation,
  selectNatureOfDuty,
  toggleOtherOccupation,
  selectedOccupationCode,
  isSelectOtherOccupation,
  defaultOccupationCode,
}) => {
  return (
    <FormGroup id="other-occupation">
      <Checkbox id={'other-occupation-checkbox'} checked={isSelectOtherOccupation} onChange={toggleOtherOccupation}>
        อาชีพเสริม
      </Checkbox>
      {isSelectOtherOccupation ? (
        <OccupationSelection
          errors={errors}
          natureOfDuties={natureOfDuties}
          occupations={occupations}
          selectedNatureOfDutyCode={selectedNatureOfDutyCode}
          selectedOccupation={selectedOccupation}
          selectedOccupationCode={selectedOccupationCode}
          selectOccupation={selectOccupation}
          selectNatureOfDuty={selectNatureOfDuty}
          defaultOccupationCode={defaultOccupationCode}
        />
      ) : null}
    </FormGroup>
  )
}

export default OtherOccupationSelection
